export function objectToIndexedArray(obj) {
  return Object.entries(obj).map(([key, value], index) => ({
    index,
    key,
    value,
    isFirst: index === 0,
    isLast: index === Object.keys(obj).length - 1
  }));
}


export function formatAmount (amount, options = {}){
  const {
    decimalPlaces = 0,
    separator = ' ',
    removeDecimals = true
  } = options;

  let numberValue;

  if (removeDecimals) {
    numberValue = Math.floor(parseFloat(amount));
  } else {
    numberValue = parseFloat(amount).toFixed(decimalPlaces);
  }

  // Split into integer and decimal parts
  const [integerPart, decimalPart] = numberValue.toString().split('.');

  // Format integer part with separator
var formattedInteger = integerPart;
  if (numberValue >= 10000) {
     formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  // Combine with decimal part if exists
  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};